module.exports = __webpack_public_path__ + "static/media/ucon12.54e32faa.JPG";